import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { ButtonBasic, TableBox } from '@lk-gtcom/ecomlab-components';
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import import_icon from './img/bx-import.svg';
import { ModalAddMassLink } from '../../../pages/AddCompetitors/ModalAddMassLink/ModalAddMassLink';
import './ModalAddMpSimple.scss';
import refresh_icon from './img/bx-refresh.svg';
import useGeneralStore from '../../../store/general';
import { useDataTable } from '../../../common/hooks';
import { KonstantinCreateProductHttps } from '../../../fetchUrls';
import usePushStore from '../../../store/toast';
import { usePushNotifications } from '../../../common/pushNotification';
import { useResponseHandler } from '../../../common/auth';
import { ModalComponent } from '../ModalComponent/ModalComponent';

const ModalAddMpSimple = ({
  currentCompetitor,
  setCurrentCompetitor,
  setIsModal
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications()
  const refContainer = useRef()

  const [name, setName] = useState('');
  const [offerId, setOfferId] = useState(null);
  const [prodId, setProdId] = useState(null);
  const [urlString, setUrlString] = useState('')
  const [recommendedPrice, setRecommendedPrice] = useState(null)
  const [selectedItems, setSelectedItems] = useState([])

  const [nameError, setNameError] = useState('');
  const [offerIdError, setOfferIdError] = useState('');

  const [isCreate, setIsCreate] = useState(false);

  const [clientData, setClientData] = useState(null)

  // Модалка
  const [isModalAddMassLink, setIsModalAddMassLink] = useState(false)
  const addPush = usePushStore((state) => state.addPush);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading } = setTableFuncs

  const offerIdHint = 'Разрешены английские и русские буквы (кроме ё), цифры, и символы .,/()[]-=_ (без пробелов). Максимальная длина — 50 знаков';

  // Добавление ссылок
  const fetchAddLinks = (links = []) => {
    const url = `https://appche1.ecomru.ru:4348/api/links/create`;

    const body = JSON.stringify({
      master_name: name,
      master_sku: offerId,
      links
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage == 'Incorrect link format' ? 'Неверный формат ссылки' : errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        const addSuccessPush = (message = "Ссылки успешно добавлены") => {
          addPush({
            type: 'success',
            title: 'Информация',
            message: message,
            timeout: 5000,
          });
        };
        addSuccessPush()
        setClientData(json)
      })
      .catch(handleRequestError)
  }

  // Список актуальных ссылок
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!offerId) return

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://appche1.ecomru.ru:4348/api/links?master_sku=${offerId}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Создание
  const fetchNewMpSimple = () => {
    const url = `${KonstantinCreateProductHttps}/master_products/simple`;

    const body = JSON.stringify({
      offer_id: offerId,
      name: name,
      attrs: {
        url: urlString,
        recommended_price: recommendedPrice
      }
    });

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        let id = json.product_id;
        const addSuccessPush = (message = "Товар успешно создан") => {
          addPush({
            type: 'success',
            title: 'Информация',
            message: message,
            timeout: 5000,
          });
        };
        addSuccessPush()
      })
      .catch(handleRequestError)
  };

  // Изменение 
  const fetchChangeMpSimple = () => {
    if (!prodId) return
    const url = `${KonstantinCreateProductHttps}/master_products/simple/${prodId}`;

    const body = JSON.stringify({
      name: name,
      attrs: {
        url: urlString,
        recommended_price: recommendedPrice
      }
    });

    fetch(url, { method: 'PUT', headers, body })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        let id = json.product_id;
        const addSuccessPush = (message = "Товар успешно изменен") => {
          addPush({
            type: 'success',
            title: 'Информация',
            message: message,
            timeout: 5000,
          });
        };
        addSuccessPush()
      })
      .catch((e) => console.error(e))
      .finally(() => { });
  };

  // Получение
  const fetchMpProdSimple = (product_id) => {
    if (!product_id) return
    const url = `${KonstantinCreateProductHttps}/master_products/simple/${product_id}`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json) {
          setOfferId(json?.offer_id || '')
          setName(json?.name || '')
          setUrlString(json?.attrs?.url || '')
          setRecommendedPrice(json?.attrs?.recommended_price || null)
        }
        setProdId(json?.product_id)
      })
      .catch(handleRequestError)
  };

  // Статус ссылки 
  const fetchChangeStatusLink = (id, status) => {
    const url = `https://appche1.ecomru.ru:4348/api/links/status`;

    const body = JSON.stringify({
      id,
      status: status
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        console.log('Статус успешно изменен')
        setTimeout(() => fetchTableData(), 500)
      })
      .catch(handleRequestError)
      .finally(() => { });
  };

  // Удаление ссылок 
  const fetchDeleteLink = (id_list) => {
    const url = `https://appche1.ecomru.ru:4348/api/links/delete`;

    const body = JSON.stringify({
      id_list
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        console.log('Ссылки успешно удалены')
        setSelectedItems([])
        setTimeout(() => fetchTableData(), 500)
      })
      .catch(handleRequestError)
  };

  const handleCheck = (data) => {
    setSelectedItems(data)
  }

  const onToggle = (e) => {
    const status = e?.active?.[0]
    const id = e?.active?.[1]
    fetchChangeStatusLink(id, !status)
  };

  const contextMenuArr = [
    {
      label: 'Удалить',
      onClick: ({ link_id }) => {
        fetchDeleteLink([link_id])
      },
    },
  ];

  useEffect(() => {
    if (clientData?.client_id || currentCompetitor) {
      setIsModalAddMassLink(false)
      fetchTableData()
    }
  }, [offerId]);

  useEffect(() => {
    fetchMpProdSimple(currentCompetitor?.product_id)
  }, [currentCompetitor]);

  return (
    <>
      {isModalAddMassLink &&
        <ModalAddMassLink
          fetchAddLinks={fetchAddLinks}
          setIsModal={setIsModalAddMassLink}
        />}

      <ModalComponent
        title={currentCompetitor?.prodId ? 'Редактировать товар' : 'Создать товар'}
        onClose={(e) => {
          setCurrentCompetitor(null)
          setIsModal(false);
        }}
        right
        child={
          <div className="modal-add-mp-simple-v2">
            <div className="modal-add-mp-simple-v2__content" ref={refContainer}>
              <div className="modal-add-mp-simple-v2__input-box">
                <InputDinamycPlaceholder
                  placeholder="Название"
                  maxLength={150}
                  changeValue={name}
                  onChange={setName}
                  textErr={nameError}
                  err={!!nameError}
                  autoComplete={false}
                  required
                  size={'s'}
                />

                <InputDinamycPlaceholder
                  placeholder="Артикул"
                  disabled={currentCompetitor}
                  changeValue={offerId}
                  onChange={setOfferId}
                  maxLength={50}
                  textErr={offerIdError}
                  err={!!offerIdError}
                  infoHeader="Артикул товара в магазине (нельзя изменить после создания)"
                  info={offerIdHint}
                  autoComplete={false}
                  required
                  size={'s'}
                />

                <InputDinamycPlaceholder
                  placeholder="Ссылка на товар"
                  changeValue={urlString}
                  onChange={setUrlString}
                  size={'s'}
                />

                <InputDinamycPlaceholder
                  type='number'
                  placeholder="Цена РРЦ"
                  changeValue={recommendedPrice}
                  onChange={setRecommendedPrice}
                  size={'s'}
                />
              </div>

              <TableBox
                {...tableProps}
                refContainer={refContainer}
                paginator={true}
                ref={paginatorRef}
                fetchCallback={fetchTableData}
                onToggle={onToggle}
                contextMenuArr={contextMenuArr}
                onCheck={handleCheck}
                child={
                  <>
                    <ButtonBasic
                      whiteGreen
                      width="160px"
                      icon={import_icon}
                      text={'Импорт ссылок'}
                      onClick={(e) => setIsModalAddMassLink(true)}
                      size="32px"
                    />

                    <ButtonBasic
                      whiteGreen
                      minWidth="auto"
                      width="160px"
                      icon={refresh_icon}
                      text={'Обновить'}
                      onClick={fetchTableData}
                      size="32px"
                    />

                    <ButtonBasic
                      red
                      minWidth="auto"
                      width="160px"
                      text={'Удалить выбранные'}
                      onClick={(e) => {
                        const current_list_id = selectedItems.map((el) => el?.link_id)
                        fetchDeleteLink(current_list_id)
                      }}
                      size="32px"
                      disabled={!selectedItems.length}
                    />
                  </>
                }
              />

            </div>

            <ButtonBasic
              green
              text={!currentCompetitor ? 'Создать' : 'Сохранить'}
              size='56px'
              style={{ minHeight: '56px' }}
              disabled={!offerId || !name}
              onClick={(e) => {
                if (!currentCompetitor) {
                  fetchNewMpSimple();
                  setIsCreate(true);
                } else {
                  fetchChangeMpSimple();
                }
              }}
            />
          </div>
        }
      />
    </>
  );
};

export { ModalAddMpSimple };
